$(function() {
    hoverPriceChange();
});

function hoverPriceChange()
{
    $(document).find('[data-same-models-product]').hover(function(e) {
        let _thisSameModel = $(this);

        let basePrice = +_thisSameModel.attr('data-base-price');
        let salePrice = +_thisSameModel.attr('data-sale-price');
        let productId = _thisSameModel.attr('data-same-models-product');
        let productSrc = _thisSameModel.attr('data-src');

        basePrice = basePrice.toLocaleString('ru-RU');
        salePrice = salePrice.toLocaleString('ru-RU');

        $('[data-price-product-id]').each(function() {
            let _thisPriceBlock = $(this)

            if (_thisPriceBlock.attr('data-price-product-id') === productId) {
                _thisPriceBlock.find('.card__price-current [data-base-price]').text(basePrice);

                if (_thisSameModel.attr('data-sale-price') !== _thisSameModel.attr('data-base-price')) {
                    _thisPriceBlock.find('.card__price-old').removeClass('d-none')
                    _thisPriceBlock.find('.card__price-old [data-sale-price]').text(salePrice)
                } else {
                    _thisPriceBlock.find('.card__price-old').addClass('d-none')
                    _thisPriceBlock.find('.card__price-old [data-sale-price]').text('')
                }
            }
        });

        _thisSameModel.closest('[data-card]').find('[data-card-favorite]').attr('data-id', productId)

        _thisSameModel.closest('[data-card]').find('.card__images').attr('href', productSrc);
    });
}
